<template>
    <div>
        <div class="overlay" @click="closeModal()"></div>
        <div class="modal-container">
            <div class="modal-body">Por favor, escolha uma Escola:</div>

            <select class="default" v-model="selectedOption" @change="selectAndEnter">
                <option v-for="(store, storeKey) in getLoginStoreOptions" :key="storeKey" :value="store" v-text="store.NMFANTCLIE"></option>
            </select>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
    name: 'LoginStoreOptionsModal',
    components: {},
    data () {
        return {
            selectedOption: null
        }
    },
    computed: {
        ...mapGetters(['getLoginStoreOptions', 'getSelectedLoginOption'])
    },
    methods: {
        ...mapActions(['setSelectedLoginOption']),
        selectAndEnter: function () {
            this.setSelectedLoginOption(this.selectedOption)
            this.$emit('closeModal')
            this.$emit('closeAndEnter')
        },
        closeModal: function () {
            this.$emit('closeModal')
        }
    }
}
</script>

<style lang="less" scoped>
.modal-container {
    z-index: 6;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    margin: auto 30px;
    border-radius: 10px;
    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
    background-color: black;
    height: max-content;
    .modal-title {
        display: flex;
        margin-top: 10px;
        align-items: flex-end;
        justify-content: center;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        font-size: 2rem;
    }
    .modal-body {
        display: flex;
        align-items: center;
        text-align: center;
        justify-content: center;
        margin-top: 20px;
        margin-bottom: 10px;
        padding: 0 10px;
    }

    .payment-methods {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .payment-method {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            margin-top: 10px;
            margin-bottom: 10px;
            input {
                margin-right: 10px;

                &:checked {
                    &::after {
                        position: relative;
                        width: 15px;
                        height: 15px;
                        border-radius: 15px;
                        top: -2px;
                        left: -1px;
                        background-color: var(--primaryColor);
                        content: '';
                        display: inline-block;
                        visibility: visible;
                        border: 2px solid white;
                    }
                }
            }
        }
    }
    .modal-footer {
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
        margin-bottom: 10px;
        margin-top: 20px;
        button {
            color:white;
            background: var(--primaryColor);
            padding: 5px 10px;
            border: none;
            border-radius: 5px;
            font-size: 1rem;
            min-width: 90px;
        }
    }

    select {
        display: block;
        margin: auto;
        margin-bottom: 30px;
        width: 90%;
    }
}
.overlay {
        z-index: 5;
        position: fixed;
        top: 0; left: 0;
        height: 100vh;
        width: 100vw;
        overflow: hidden;
        background: rgba(0, 0, 0, 0.21);
    }
</style>
